export const UserLegalEntityColumns = [
    {
        displayName: 'Legal Entity',
        sortColumnName: 'legalEntity',
        dataType: 'string',
        dataKey: 'text',
        settings: { sort: false, filter: false, multiple: false },
    },
    {
        displayName: 'Actions',
        sortColumnName: 'actions',
        dataType: 'actions',
        dataKey: 'actions',
        settings: { sort: false, filter: false, multiple: false },
        css: 'pad-end',
    },
];

export const UserLegalEntityFilters = {
    sorting: null,

    pagination: null,

    advancedFilters: null,
};
